module.exports = {
  "item-box": {
    "position": "relative"
  },
  "item-text": {
    "textAlign": "center"
  },
  "active-box": {
    "width": "18",
    "paddingLeft": "12",
    "position": "absolute",
    "left": 0,
    "top": 0,
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "line-box": {
    "width": "6",
    "borderRadius": "4"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-b18735f4!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-side-nav/index.vue
// module id = 528
// module chunks = 0 1